import TemplateView from "../../../TemplateView";
import messageResource from '../../../messageResource'

export const SCOPE_CELL_STATUS = {
    ALL: 0,
    NOT_SELECTED: 1,
    NOT_ALLOWED: 2,
    SELECTED: 3,
    NO_ACCESS: 4,
}

export default class ScopeCell extends TemplateView {

    constructor({
        onClickCb = () => {},
        detailsBlock = null,
        notAllowedTextKey = '',
        notSelectedTextKey = '',
        selectedTextKey = '',
        noAccessTextKey = '',
    }) {
        super()

        this.params = {
            onClickCb,
            detailsBlock,
            notAllowedTextKey,
            notSelectedTextKey,
            selectedTextKey,
            noAccessTextKey,
        }

        this.state = {
            highlighted: false,
            disabled: false,
            status: SCOPE_CELL_STATUS.NOT_ALLOWED,
            allSelectedTextKey: '',
        }

        this.onStateChanged(() => {
            this.updateCellClass()
            this.updateLabel()
            this.toggleIcon()
        })
    }

    templateHtml() {
        return "<div class='userPanelScopeCell'>" +
               "    <div class='icon'></div>" +
               "    <div class='label'></div>" +
               "    <div class='detailsPlaceholder'></div>" +
               "</div>"
    }

    afterRender() {
        this.$el.on('click', (e) => {
            if (!this.state.disabled) {
                this.params.onClickCb(this.$el, e)
            }
        })
        this.$label = this.find('.label')
        this.$icon = this.find('.icon')

        this.params.detailsBlock.init(this.find('.detailsPlaceholder'))
    }

    updateCellClass() {
        this.$el
            .removeClass()
            .addClass('userPanelScopeCell')
            .toggleClass('all', this.state.status === SCOPE_CELL_STATUS.ALL)
            .toggleClass('notSelected', this.state.status === SCOPE_CELL_STATUS.NOT_SELECTED)
            .toggleClass('notAllowed', this.state.status === SCOPE_CELL_STATUS.NOT_ALLOWED)
            .toggleClass('selected', this.state.status === SCOPE_CELL_STATUS.SELECTED)
            .toggleClass('noAccess', this.state.status === SCOPE_CELL_STATUS.NO_ACCESS)
            .toggleClass('disabled', this.state.disabled)
            .toggleClass('highlighted', this.state.highlighted)
    }

    toggleIcon() {
        this.$icon.toggle(this.state.status === SCOPE_CELL_STATUS.ALL || this.state.status === SCOPE_CELL_STATUS.NOT_ALLOWED)
    }

    updateLabel() {
        this.$label.toggle(this.state.status !== SCOPE_CELL_STATUS.SELECTED)
        if (this.state.status !== SCOPE_CELL_STATUS.SELECTED)
            this.$label.text(this.getLabelText())
    }

    getLabelText() {
        switch (this.state.status) {
            case SCOPE_CELL_STATUS.ALL:
                return messageResource.getMessage(this.state.allSelectedTextKey)
            case SCOPE_CELL_STATUS.NOT_ALLOWED:
                return messageResource.getMessage(this.params.notAllowedTextKey)
            case SCOPE_CELL_STATUS.NOT_SELECTED:
                return messageResource.getMessage(this.params.notSelectedTextKey)
            case SCOPE_CELL_STATUS.SELECTED:
                return messageResource.getMessage(this.params.selectedTextKey)
            case SCOPE_CELL_STATUS.NO_ACCESS:
                return messageResource.getMessage(this.params.noAccessTextKey)
        }
    }

}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/ScopeCell.js